/*
 * This uses intersection observers to detect when an element becomes sticky.
 * It's most useful for detecting when a `position: sticky` element becomes stuck.
 * It's not useful for making an element `position: fixed` when sticky, because
 * the intersection observer ends up getting triggered repeatedly.
 */

import each from 'lodash/each'

const stickyElementSelector = '[data-sticky]'
const stickyClassname = 'is-stuck'

function onIntersect(entries) {
  const entry = entries[0]
  // The observer could be called on an entry that's no longer in the DOM, and we don't care about those.
  if (!entry.target.isConnected) return
  // console.log(
  //   `isIntersecting ${entry.isIntersecting}`,
  //   `intersectionRatio ${entry.intersectionRatio}`,
  //   `intersectionRect.top ${entry.intersectionRect.top}`,
  //   `rootBounds.top ${entry.rootBounds.top}`,
  //   `intersectionRect ${entry.intersectionRect}`,
  //   `rootBounds ${entry.rootBounds}`,
  // )
  // Only count as sticky if we've scrolled below where the element naturally is:
  entry.target.classList.toggle(
    stickyClassname,
    !entry.isIntersecting &&
      entry.intersectionRatio < 1 &&
      entry.intersectionRect &&
      entry.rootBounds &&
      entry.intersectionRect.top <= entry.rootBounds.top,
  )
}

let observers = []

function setupStickyObserver(el) {
  if (el.hasAttribute('data-sticky-initialized')) {
    return
  }
  const style = getComputedStyle(el)
  const initialBackgroundSize = style.backgroundSize
  el.style.backgroundSize = style.getPropertyValue('--sticky-offset')
  // + 1 is required to get the element to intersect with the browser window.
  const stickyOffset = (parseInt(style.getPropertyValue('background-size'), 10) || 0) + 1
  el.style.backgroundSize = initialBackgroundSize
  const observer = new IntersectionObserver(onIntersect, {
    rootMargin: `-${stickyOffset}px 0px 0px 0px`,
    threshold: [1],
  })
  observer.observe(el)
  observers.push(observer)
  el.setAttribute('data-sticky-initialized', '1')
}

function setupStickyObservers(container) {
  if (!container) {
    return
  }

  // Initialize existing elements:

  const existingEls = container.querySelectorAll(stickyElementSelector)
  if (existingEls.length) {
    each(existingEls, (el) => {
      setupStickyObserver(el)
    })
  }

  // Observe new elements:

  const observer = new MutationObserver((mutations) => {
    each(mutations, (mutation) => {
      each(mutation.addedNodes, (node) => {
        if (node.nodeType !== 1) {
          return
        }

        const els = node.querySelectorAll(stickyElementSelector)
        if (!els.length) {
          return
        }

        each(els, (el) => {
          setupStickyObserver(el)
        })
      })
    })
  })

  observer.observe(container, {
    childList: true,
    subtree: true,
    attributes: false,
    characterData: false,
  })
}

function destroyStickyObservers() {
  observers.forEach((observer) => observer.disconnect())
  observers = []
}

export { setupStickyObservers, destroyStickyObservers }
